export default __webpack_public_path__ + "static/media/current-onboarding-screens.d04080ec.png";